module.exports = __webpack_public_path__ + "static/media/portadamovil.d170f8ae.png";